var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container",staticClass:"marquee"},[_c('div',{staticClass:"marquee__inner"},[_c('div',{staticClass:"marquee__items",style:({ animationDuration: _vm.animationDuration })},_vm._l((_vm.marqueeItems),function(item,i){return _c('div',{key:`item-${i}`,style:({ textIndent: _vm.textIndent }),domProps:{"innerHTML":_vm._s(item.name)}})}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }